// (B) 플레인 Divider — antd Divider 대체(순수 시각 컴포넌트라 라이브러리 불필요).
// `.om-divider` + orientation/with-text hook. base 시각은 styles/omwDivider.css(antd CSS-in-JS 대체).
import type { OmwDividerProps } from '../api/OmwDivider'
import { cx } from './cx'
import '../styles/omwDivider.css'

export function PlainDivider({ type = 'horizontal', className, style, children }: OmwDividerProps) {
  const hasText = children != null && children !== false
  return (
    <div
      role="separator"
      aria-orientation={type}
      className={cx(
        'om-divider',
        `om-divider-${type}`,
        hasText && 'om-divider-with-text',
        className,
      )}
      style={style}
    >
      {hasText && <span className="om-divider-inner-text">{children}</span>}
    </div>
  )
}
